import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
// import { email } from '@config';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Hi, this is</h1>;
  const two = <h2 className="big-heading">Syed A. Haider</h2>;
  const three = <h3 className="small-heading">Final Year | IIT(ISM) Dhanbad</h3>;
  const four = (
    <>
      <p>
        I'm a final year B.Tech student at IIT (ISM) Dhanbad. I'm keenly interested in Android and&nbsp; 
        <a href="https://roetron.itch.io/" target="_blank" rel="noreferrer">
          Game Development 
        </a>
        .
        I love competing in online&nbsp;
        <a href="https://codeforces.com/profile/roet" target="_blank" rel="noreferrer">
          coding 
        </a>
        &nbsp;contests, and sometimes, I&nbsp;
        <a href="https://www.behance.net/syedhaider7" target="_blank" rel="noreferrer"> design
        </a>&nbsp;stuff.
      </p>
    </>
  );
  const five = (
    <a
      className="email-link"
      href="mailto:syed.ahaider@outlook.com"
      target="_blank"
      rel="noreferrer">
        Let's Connect!
    </a>
    
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
